__turbopack_context__.v({
  "leagueCard": "leaguecard-module-scss-module__90rYNG__leagueCard",
});
